/*
 * action 类型
 */

export const SELECT_ITEM = 'SELECT_ITEM'
export const SELECT_GROUP = 'SELECT_GROUP'
export const UPDATE_ITEM_PROPS = 'UPDATE_ITEM_PROPS'


/*
 * action 创建函数
 */

export function selectItem(item, formKey) {
    return { type: SELECT_ITEM, item, formKey }
}

export function selectGroup(groupItem) {
    return { type: SELECT_GROUP, groupItem }
}

export function updateItemProps(item) {
    return { type: UPDATE_ITEM_PROPS, item }
}